import React from "react";
import { Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import EnglishIdLayout from "./EnglishIdLayout";
import { Protected } from "./Protected";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Activate from "./pages/Activate";
import PublicCard from "./pages/PublicCard";
import StudentDashboard from "./pages/StudentDashboard";
import FamilyDashboard from "./pages/FamilyDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminStudentDetail from "./pages/AdminStudentDetail";

/**
 * `AuthProvider` wraps every page here so AuthContext is only initialised
 * when the user is actually inside `/english-id/*`. The marketing landing at
 * `/` keeps running untouched.
 */
export const EnglishIdWrapper = ({ children }) => (
  <AuthProvider>{children}</AuthProvider>
);

export const englishIdRoutes = (
  <>
    <Route
      path="/english-id/card/:token"
      element={
        <EnglishIdWrapper>
          <PublicCard />
        </EnglishIdWrapper>
      }
    />
    <Route
      path="/english-id/activate/:token"
      element={
        <EnglishIdWrapper>
          <EnglishIdLayout />
        </EnglishIdWrapper>
      }
    >
      <Route index element={<Activate />} />
    </Route>
    <Route
      path="/english-id"
      element={
        <EnglishIdWrapper>
          <EnglishIdLayout />
        </EnglishIdWrapper>
      }
    >
      <Route index element={<Landing />} />
      <Route path="login" element={<Login />} />
      <Route
        path="student"
        element={
          <Protected role="student">
            <StudentDashboard />
          </Protected>
        }
      />
      <Route
        path="family"
        element={
          <Protected role="family">
            <FamilyDashboard />
          </Protected>
        }
      />
      <Route
        path="admin"
        element={
          <Protected role="admin">
            <AdminDashboard />
          </Protected>
        }
      />
      <Route
        path="admin/students/:id"
        element={
          <Protected role="admin">
            <AdminStudentDetail />
          </Protected>
        }
      />
    </Route>
  </>
);
